import { useState, useEffect } from 'react';

export function useIsPWA(): boolean {
  const [isPWA, setIsPWA] = useState(false);

  useEffect(() => {
    const checkIfPWA = () => {
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
      const isIOSStandalone = (window.navigator as any).standalone === true;
      const isInAppBrowser = window.matchMedia('(display-mode: fullscreen)').matches;

      return isStandalone || isIOSStandalone || isInAppBrowser;
    };

    setIsPWA(checkIfPWA());

    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    const handleChange = (e: MediaQueryListEvent) => {
      setIsPWA(e.matches || (window.navigator as any).standalone === true);
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return isPWA;
}
